import { API_BASE_URL, getRequest } from "../../../../api";

const getToken = () => sessionStorage.getItem("token");

export const fetchEventDetailsApi = (eventId) =>
    getRequest({
        url: `${API_BASE_URL}/api/events/${eventId}`,
        token: getToken(),
    });

export const fetchEventAssignmentsApi = (eventId) =>
    getRequest({
        url: `${API_BASE_URL}/api/assignments/event/${eventId}`,
        token: getToken(),
    });

export const fetchAssignmentsMapApi = async (eventIds = []) => {
    const uniqueIds = [...new Set((eventIds || []).filter(Boolean))];

    const entries = await Promise.all(
        uniqueIds.map(async (eventId) => {
            try {
                const response = await fetchEventAssignmentsApi(eventId);
                return [eventId, response.data || []];
            } catch (error) {
                return [eventId, []];
            }
        })
    );

    return Object.fromEntries(entries);
};
